import React, { Component } from 'react';
import instance from "../axios-instance";
import Systems from "../SystemFunction";
import MainSettingContext from './MainSettingContext';
import Swal from 'sweetalert2';
import { t } from './i18n';

class Redeemreward extends Component {
    static contextType = MainSettingContext;
    constructor(props) {
        super(props)
        this.state = {
            rewardlist: [],
            historylist: [],
            activePage: 1,
            pagecount: 1,
            loading: true,
            loadingHistory: false,
            activeTab: 0,
            loginstate: props.loginstate || false,
            username: props.username || "",
            userid: props.userid || null,
            point: props.point || 0,
            tblprofile: props.tblprofile || null,
            balance: props.balance || 0,
        }
    }

    async componentDidMount() {
        await this.loadRewardList(1);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.point !== this.props.point) {
            this.setState({ point: this.props.point });
        }
        if (prevProps.tblprofile !== this.props.tblprofile) {
            this.setState({ tblprofile: this.props.tblprofile });
        }
    }

    get lang() {
        return this.props.language || this.context?.language || localStorage.getItem('lang') || 'th';
    }

    loadRewardList = async (page) => {
        this.setState({ loading: true });
        try {
            const res = await instance.get("/api/v1/rewardlist", { params: { Cat_ID: 0, page } });
            if (res.data.status === 200) {
                this.setState({
                    rewardlist: res.data.message.products || [],
                    pagecount: res.data.message.pagecount || 1,
                    activePage: page,
                    loading: false
                });
            } else {
                this.setState({ rewardlist: [], loading: false });
            }
        } catch (err) {
            this.setState({ rewardlist: [], loading: false });
        }
    }

    loadHistory = async () => {
        const { userid } = this.state;
        if (!userid) return;
        this.setState({ loadingHistory: true });
        try {
            const res = await instance.post("/api/v1/finduserhistory", { memberid: userid, page: 1 });
            if (res.data.status === 200) {
                this.setState({ historylist: res.data.message.products || [], loadingHistory: false });
            } else {
                this.setState({ historylist: [], loadingHistory: false });
            }
        } catch (err) {
            this.setState({ historylist: [], loadingHistory: false });
        }
    }

    handleRedeem = async (item) => {
        const { loginstate, point, tblprofile } = this.state;
        const _lang = this.lang;
        if (!loginstate) {
            Swal.fire({ icon: 'warning', title: t(_lang, 'login_first_title'), text: t(_lang, 'login_first_text'), confirmButtonText: t(_lang, 'ok') });
            return;
        }
        const userPoint = tblprofile?.Point ?? point ?? 0;
        const needed = item.point || item.Point || 0;
        if (userPoint < needed) {
            Swal.fire({ icon: 'error', title: t(_lang, 'not_enough_points_title'), text: `${t(_lang,'you_have_label')} ${userPoint} ${t(_lang,'point_unit')} ${t(_lang,'needed_label')} ${needed} ${t(_lang,'point_unit')}`, confirmButtonText: t(_lang, 'ok') });
            return;
        }
        const confirm = await Swal.fire({
            icon: 'question',
            title: `${t(_lang,'redeem_verb')} ${item.name}`,
            html: `${t(_lang,'use_verb_label')} <b>${needed.toLocaleString()}</b> ${t(_lang,'point_unit')} ${t(_lang,'to_redeem_for_label')} <b>${item.name}</b>`,
            showCancelButton: true,
            confirmButtonText: t(_lang, 'confirm'),
            cancelButtonText: t(_lang, 'cancel'),
        });
        if (!confirm.isConfirmed) return;
        try {
            // [2026-10-19] เดิมเรียก /api/v1/redeemreward (ไม่มีในหลังบ้าน) -> ใช้ /api/v1/redeem/initial (Jackpotlist.redeem: rewardid + member_id)
            const _tk = localStorage.getItem('auth_token');
            const res = await instance.post("/api/v1/redeem/initial", {
                rewardid: item.id,
                playerid: this.state.userid,
                System: Systems,
            }, { headers: _tk ? { Authorization: `Bearer ${_tk}` } : {} });
            if (res.data.status === 200) {
                Swal.fire({ icon: 'success', title: t(_lang, 'redeem_success_title'), text: t(_lang, 'redeem_success_text'), confirmButtonText: t(_lang, 'ok') });
                await this.loadRewardList(this.state.activePage);
            } else {
                Swal.fire({ icon: 'error', title: t(_lang, 'failed_title'), text: res.data.message || t(_lang, 'try_again'), confirmButtonText: t(_lang, 'ok') });
            }
        } catch (err) {
            Swal.fire({ icon: 'error', title: t(_lang, 'error'), text: t(_lang, 'try_again'), confirmButtonText: t(_lang, 'ok') });
        }
    }

    render() {
        const lang = this.props.language || this.context?.language || localStorage.getItem('lang') || 'th';
        const { rewardlist, historylist, loading, loadingHistory, activeTab, activePage, pagecount, point, tblprofile } = this.state;
        const userPoint = tblprofile?.Point ?? point ?? 0;

        return (
            <>
                <div className="container p-0 x-margin-top-v3">
                    <div className="row m-0 border-shadow-title">
                        <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                            <div className="text-center bg-title-web" style={{ paddingTop: 50 }}>
                                <div>
                                    <div className="text-title text-white-v1 text-center">
                                        <div className="d-flex justify-content-between">
                                            <div className="text-white-v1-deposit">
                                                <a role="button" href="/event">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="currentColor" className="bi bi-arrow-left-circle text-white" viewBox="0 0 16 16">
                                                        <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
                                                    </svg>
                                                </a>
                                            </div>
                                            <div className="text-white-v1-deposit">
                                                <h5>{t(lang,'redeem_title')}</h5>
                                            </div>
                                            <div>{/**/}</div>
                                        </div>
                                        <hr className="mt-0" />
                                    </div>
                                </div>
                            </div>

                            <div className="p-2">
                                <div className="d-flex justify-content-between align-items-center mb-3 px-1"
                                    style={{ background: "rgba(255,255,255,0.07)", borderRadius: 12, padding: "10px 14px" }}>
                                    <div>
                                        <small style={{ opacity: 0.7, fontSize: 12 }}>{t(lang,'my_points_label')}</small>
                                        <div style={{ fontWeight: 700, fontSize: 20, color: "#f6dd8b" }}>
                                            {Number(userPoint).toLocaleString()}
                                            <span style={{ fontSize: 12, marginLeft: 4, opacity: 0.8 }}>pts</span>
                                        </div>
                                    </div>
                                    <div style={{ fontSize: 30 }}>⭐</div>
                                </div>

                                <div className="d-flex mb-3" style={{ gap: 8 }}>
                                    <button
                                        onClick={() => { this.setState({ activeTab: 0 }); this.loadRewardList(1); }}
                                        style={{
                                            flex: 1, padding: "8px 0", borderRadius: 999, border: "none", cursor: "pointer", fontWeight: 600, fontSize: 13,
                                            background: activeTab === 0 ? "linear-gradient(180deg,#f6dd8b,#d6a739)" : "rgba(255,255,255,0.1)",
                                            color: activeTab === 0 ? "#2b1c00" : "#fff"
                                        }}>
                                        {t(lang,'reward_items_tab')}
                                    </button>
                                    <button
                                        onClick={() => { this.setState({ activeTab: 1 }); this.loadHistory(); }}
                                        style={{
                                            flex: 1, padding: "8px 0", borderRadius: 999, border: "none", cursor: "pointer", fontWeight: 600, fontSize: 13,
                                            background: activeTab === 1 ? "linear-gradient(180deg,#f6dd8b,#d6a739)" : "rgba(255,255,255,0.1)",
                                            color: activeTab === 1 ? "#2b1c00" : "#fff"
                                        }}>
                                        {t(lang,'redeem_history_tab')}
                                    </button>
                                </div>

                                {activeTab === 0 && (
                                    <>
                                        {loading ? (
                                            <div className="text-center py-5">
                                                <div className="spinner-border text-light" role="status" />
                                                <p className="mt-2 text-white-v1">{t(lang,'loading')}</p>
                                            </div>
                                        ) : rewardlist.length === 0 ? (
                                            <div className="text-center py-5">
                                                <div style={{ fontSize: 48 }}>🎁</div>
                                                <p className="text-white-v1 mt-2">{t(lang,'no_rewards_yet')}</p>
                                            </div>
                                        ) : (
                                            <>
                                                <div className="row m-0" style={{ gap: 0 }}>
                                                    {rewardlist.map((item, idx) => {
                                                        const needed = item.point || item.Point || 0;
                                                        const canRedeem = userPoint >= needed;
                                                        return (
                                                            <div key={idx} className="col-6 p-1">
                                                                <div style={{
                                                                    borderRadius: 14, overflow: "hidden",
                                                                    background: "rgba(255,255,255,0.07)",
                                                                    border: "1px solid rgba(255,255,255,0.12)",
                                                                    opacity: canRedeem ? 1 : 0.6
                                                                }}>
                                                                    {item.linkpicture ? (
                                                                        <img src={item.linkpicture} alt={item.name} style={{ width: "100%", height: 110, objectFit: "cover" }} />
                                                                    ) : (
                                                                        <div style={{ width: "100%", height: 110, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(255,255,255,0.05)", fontSize: 36 }}>🎁</div>
                                                                    )}
                                                                    <div className="p-2">
                                                                        <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                            {item.name}
                                                                        </div>
                                                                        <div style={{ fontSize: 12, color: "#f6dd8b", marginBottom: 6 }}>
                                                                            ⭐ {Number(needed).toLocaleString()} pts
                                                                        </div>
                                                                        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.6)", marginBottom: 8 }}>
                                                                            {t(lang,'stock_remaining')} {item.qty ?? 0}
                                                                        </div>
                                                                        <button
                                                                            onClick={() => this.handleRedeem(item)}
                                                                            disabled={!canRedeem || item.qty <= 0}
                                                                            style={{
                                                                                width: "100%", border: "none", borderRadius: 999, padding: "6px 0", fontWeight: 700, fontSize: 12, cursor: canRedeem && item.qty > 0 ? "pointer" : "not-allowed",
                                                                                background: canRedeem && item.qty > 0 ? "linear-gradient(180deg,#f6dd8b,#d6a739)" : "rgba(255,255,255,0.15)",
                                                                                color: canRedeem && item.qty > 0 ? "#2b1c00" : "rgba(255,255,255,0.5)"
                                                                            }}>
                                                                            {item.qty <= 0 ? t(lang,'out_of_stock') : canRedeem ? t(lang,'redeem_now') : t(lang,'not_enough_points')}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                {pagecount > 1 && (
                                                    <div className="d-flex justify-content-center mt-3" style={{ gap: 8 }}>
                                                        {activePage > 1 && (
                                                            <button onClick={() => this.loadRewardList(activePage - 1)}
                                                                style={{ background: "rgba(255,255,255,0.1)", border: "none", borderRadius: 999, padding: "6px 14px", color: "#fff", cursor: "pointer" }}>
                                                                ‹
                                                            </button>
                                                        )}
                                                        <span style={{ padding: "6px 14px", fontSize: 13 }}>{activePage} / {pagecount}</span>
                                                        {activePage < pagecount && (
                                                            <button onClick={() => this.loadRewardList(activePage + 1)}
                                                                style={{ background: "rgba(255,255,255,0.1)", border: "none", borderRadius: 999, padding: "6px 14px", color: "#fff", cursor: "pointer" }}>
                                                                ›
                                                            </button>
                                                        )}
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}

                                {activeTab === 1 && (
                                    <>
                                        {loadingHistory ? (
                                            <div className="text-center py-5">
                                                <div className="spinner-border text-light" role="status" />
                                            </div>
                                        ) : historylist.length === 0 ? (
                                            <div className="text-center py-5">
                                                <div style={{ fontSize: 48 }}>📦</div>
                                                <p className="text-white-v1 mt-2">{t(lang,'no_redeem_history')}</p>
                                            </div>
                                        ) : (
                                            <div>
                                                {historylist.map((item, idx) => (
                                                    <div key={idx} style={{
                                                        background: "rgba(255,255,255,0.07)", borderRadius: 12,
                                                        padding: "12px 14px", marginBottom: 8,
                                                        border: "1px solid rgba(255,255,255,0.1)"
                                                    }}>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <div style={{ fontWeight: 600, fontSize: 14 }}>{item.name || t(lang,'reward_items_tab')}</div>
                                                                <div style={{ fontSize: 12, opacity: 0.6, marginTop: 2 }}>
                                                                    {item.Dateadd ? new Date(item.Dateadd).toLocaleDateString('th-TH') : ""}
                                                                </div>
                                                            </div>
                                                            <div style={{
                                                                padding: "3px 10px", borderRadius: 999, fontSize: 11, fontWeight: 700,
                                                                background: item.rewardstats === 1 ? "rgba(40,167,69,0.2)" : "rgba(255,193,7,0.2)",
                                                                color: item.rewardstats === 1 ? "#5cb85c" : "#ffc107"
                                                            }}>
                                                                {item.rewardstats === 1 ? t(lang,'status_approve') : t(lang,'status_pending')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>

                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Redeemreward;
